import share from './share'
import setTitle from './setTitle'
import setTitleColor from './setTitleColor'
import hideShareBtn from './hideShareBtn'
import extractImg from './extractImg'
export default {
	share,
	setTitle,
	setTitleColor,
	hideShareBtn,
	extractImg
}



// WEBPACK FOOTER //
// ./src/utils/bridge/index.js